const SESSION_STORAGE_SEARCH_KEY = 'advSearchFilters'

export default {

    reset() {
        window.sessionStorage.removeItem(SESSION_STORAGE_SEARCH_KEY)
    },

    getAll() {
        return JSON.parse(window.sessionStorage.getItem(SESSION_STORAGE_SEARCH_KEY)) || {}
    },

    set(data) {
        window.sessionStorage.setItem(SESSION_STORAGE_SEARCH_KEY, JSON.stringify(data))
    },

    getValue(key) {
        const data = this.getAll()

        return data[key]
    },

    setValue(key, value) {
        const data = this.getAll()
        data[key] = value
        this.set(data)
    },

    removeValue(key, value) {
        const data = this.getAll()
        if (Array.isArray(data[key])) {
            delete data[key].splice([data[key].indexOf(value)], 1)
            if (data[key].length === 0) {
                delete data[key]
            }
        } else {
            delete data[key]
        }
        this.set(data)
    },

    generateUrl(baseUrl, advandedSearch) {
        const data = this.getAll()
        if (advandedSearch && advandedSearch === 'advancedSearch') {
            const region = data.region_i18n ? data.region_i18n : ''
            const dpt = data.dpt_i18n ? data.dpt_i18n : ''
            baseUrl = [baseUrl, region, dpt].join('/')
        }
        delete data.region
        delete data.dpt
        delete data.region_i18n
        delete data.dpt_i18n
        delete data.thematic
        delete data.city
        delete data.city_i18n
        const filters = []
        Object.entries(data).forEach(entry => {
            if (!entry[1] || entry[1].length === 0) return
            if (Array.isArray(entry[1])) {
                entry[1].forEach(value => {
                    if (entry[0].length !== 0) {
                        filters.push([entry[0], value].join('='))
                    }
                })
            } else {
                filters.push([entry[0], entry[1]].join('='))
            }
        })
        return filters.length > 0 ? [baseUrl, filters.join('&')].join('?') : baseUrl
    }
}



// WEBPACK FOOTER //
// ./src/apps/Front/private/js/components/searchFiltersStorage.js